import type { SxProps, Theme } from "@mui/material";
import { Box, Stack } from "@mui/material";
import type { PropsWithChildren } from "react";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";

interface Props {
  isLoading?: boolean;
  sx?: SxProps<Theme>;
  withTopBorder?: boolean;
  flush?: boolean;
}

const PanelSection = ({ isLoading, sx, withTopBorder, flush, children }: PropsWithChildren<Props>) => (
  <Stack
    spacing={1.5}
    sx={[
      {
        border: flush ? 0 : 1,
        borderTop: withTopBorder && !flush ? 1 : 0,
        borderRadius: flush ? 0 : "4px",
        borderColor: "divider",
        bgcolor: "background.default",
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {isLoading ? (
      <Box sx={{ height: "8rem" }}>
        <InlineLoader />
      </Box>
    ) : (
      children
    )}
  </Stack>
);

export default PanelSection;
